import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import ReactSelect from 'react-select';
import FieldErrorMessage from '../FieldErrorMessage';
import Hint from "../Hint";

const Select = ( props ) => {
    const { control, register, unregister } = useFormContext();
    const { label, name, options, isRequired, isSearchable, hint = '', rules, defaultValue, reset = null } = props;

    useEffect( () => {
        return () => {
            unregister( name )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <div className={`form-item form-item--select`}>
            <label htmlFor={name}>
                {label}
                {isRequired && <span className="required">*</span>}
                {hint && <Hint hint={hint}/>}
            </label>
            <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={defaultValue}
                render={( { onChange, value, name, ref } ) => (
                    <ReactSelect
                        ref={reset}
                        placeholder="- Select a value -"
                        name={name}
                        refs={register(rules)}
                        inputRef={ref}
                        defaultValue={defaultValue}
                        className="form-item--select-container"
                        options={options}
                        value={options.find( c => c.value === value )}
                        onChange={val => onChange( val.value )}
                        isSearchable={isSearchable}
                        classNamePrefix="react-select"
                    />
                )}
            />
            <FieldErrorMessage name={name}/>
        </div>
    );
};

Select.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf( PropTypes.object ).isRequired,
    isRequired: PropTypes.bool,
    isSearchable: PropTypes.bool,
    // @todo: How to make it required conditionaly?
    rules: PropTypes.objectOf( PropTypes.any ),
};

Select.defaultProps = {
    isRequired: true,
    isSearchable: false,
    rules: null,
    defaultValue: ""
};

export default Select;
